import type { pilots as en } from '@/i18n/locales/en/pilots';
import type { Translation } from '@/i18n/types';

export const pilots: Translation<typeof en> = {
  page: {
    title: 'Pilotos',
    lead: 'Pilotos en curso en {{company}}.',
    noScope: 'Selecciona una empresa para ver sus pilotos.',
    listTitle: 'Pilotos',
    empty: 'Aún no hay pilotos.',
  },
  status: {
    draft: 'Borrador',
    baseline: 'Línea base',
    active: 'Activo',
    interim_review: 'Evaluación intermedia',
    final_review: 'Evaluación final',
    completed: 'Completado',
    scaled: 'Escalado',
  },
  phases: {
    baseline: 'Medición inicial',
    interim: 'Evaluación intermedia',
    final: 'Evaluación final',
  },
  kpis: {
    participationRate: 'Tasa de participación',
    activeUsers: 'Usuarios activos',
    dailyUsage: 'Uso diario',
    satisfaction: 'Satisfacción de los empleados',
    avgVitality: 'Vitalidad media',
    aiCoachUsage: 'Uso del coach IA',
    challengeUsage: 'Uso de challenges',
    rolloutReadiness: 'Recomendación de despliegue',
  },
  form: {
    title: 'Nuevo piloto',
    name: 'Nombre',
    startDate: 'Fecha de inicio',
    departments: 'Departamentos',
    submit: 'Crear piloto',
  },
  detail: {
    title: 'Piloto',
    lead: 'Evaluación del piloto de vitalidad con KPI, tendencias, conclusiones y una decisión de despliegue fundamentada.',
    exportPdf: 'Exportar informe (PDF)',
    hero: {
      badge: {
        success: 'Piloto superado',
        partial: 'Piloto en curso',
        atRisk: 'Requiere atención',
        pending: 'Piloto en marcha',
      },
      goals: {
        success: 'Todos los objetivos de KPI alcanzados',
        partial: 'Algunos objetivos de KPI alcanzados',
        atRisk: 'Objetivos de KPI aún no alcanzados',
        pending: 'Todavía no hay suficientes datos para una recomendación',
      },
      headlinePrefix: {
        success:
          'El piloto demuestra que NOLATR Fit mejora la vitalidad de forma medible — recomendación:',
        partial: 'El piloto muestra mejoras — recomendación:',
        atRisk: 'El piloto aún no muestra una mejora medible — recomendación:',
        pending: 'Todavía no hay suficientes datos para una recomendación sobre',
      },
      headlineAdvice: {
        success: 'desplegarlo a toda la organización.',
        partial: 'ampliar el piloto para obtener más datos.',
        atRisk: 'corregir esto antes de desplegarlo.',
        pending: 'el despliegue.',
      },
    },
    summary: {
      participation: 'Participación',
      dailyActive: 'Activos a diario',
      stress: 'Estrés',
      sleep: 'Sueño',
      goal: 'objetivo {{value}}%',
      vsBaseline: 'vs. línea base',
      minutes: '{{value}} min',
    },
    aiSummaryTitle: 'Resumen de IA',
    recommendationEmpty: 'Aún no se ha escrito ningún resumen.',
    kpisTitle: 'KPI',
    chartTitle: 'Vitalidad y actividad durante el piloto',
    chartCurrent: 'Actual',
    noData: 'Aún no hay datos.',
    participantCount: '{{count}} participantes',
    evaluationsTitle: 'Conclusiones y recomendaciones',
    conclusionsTitle: 'Conclusiones',
    recommendationsListTitle: 'Recomendaciones',
    evaluationsEmpty: 'Aún no se han registrado evaluaciones.',
    evaluationPhase: 'Fase',
    evaluationConclusions: 'Conclusiones',
    evaluationRecommendations: 'Recomendaciones',
    decisionTitle: 'Decisión',
    scaleRequiresCompleted: 'El despliegue solo es posible una vez completada la evaluación final.',
  },
  actions: {
    new: 'Nuevo piloto',
    cancel: 'Cancelar',
    save: 'Guardar',
    edit: 'Editar',
    addEvaluation: 'Añadir evaluación',
    extend: 'Ampliar',
    scale: 'Escalar',
  },
};
